interface CustomTimeIconProps {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const CustomTimeIcon = ({
  className,
  fill = '#888888',
  width = 24,
  height = 24,
  ...props
}: CustomTimeIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M20.8745 12.0005C20.8745 7.09912 16.9018 3.12526 12.0005 3.125C7.09896 3.125 3.125 7.09896 3.125 12.0005C3.12526 16.9018 7.09912 20.8745 12.0005 20.8745C16.9016 20.8742 20.8742 16.9016 20.8745 12.0005ZM23.1245 12.0005C23.1242 18.1443 18.1443 23.1242 12.0005 23.1245C5.85648 23.1245 0.875264 18.1444 0.875 12.0005C0.875 5.85632 5.85632 0.875 12.0005 0.875C18.1444 0.875264 23.1245 5.85648 23.1245 12.0005Z"
      fill={fill}
    />
    <path
      d="M10.8752 8.5C10.8752 7.87868 11.3789 7.375 12.0002 7.375C12.6216 7.375 13.1252 7.87868 13.1252 8.5V11.5337L14.7952 13.2051L14.8728 13.29C15.2331 13.7319 15.207 14.3841 14.7952 14.7959C14.3833 15.2073 13.7325 15.2322 13.2908 14.8721L13.2043 14.7959L11.2048 12.7949C10.994 12.584 10.8752 12.2978 10.8752 11.9995V8.5Z"
      fill={fill}
    />
  </svg>
);
